<ng-template #phoneCallBillingModal let-c="close" let-d="dismiss">
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      <i class="fas fa-phone"></i>&nbsp;Phone Call — {{ phoneNumber }}
    </h5>
    <div class="ml-auto mr-3">
      <span class="badge badge-light" style="font-size: 1.1em; font-family: monospace;">
        <i class="fas fa-clock"></i>&nbsp;{{ timerDisplay }}
      </span>
    </div>
    <button type="button" class="close text-white" aria-label="Close" (click)="d()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Matter Finder (shown when matter not known) -->
    <div *ngIf="!matterSelected">
      <h5>Select a Matter</h5>
      <p class="text-muted">This phone number is not on a matter page. Select a matter to bill against.</p>

      <div *ngIf="loadingMatters" class="text-center py-3">
        <i class="fas fa-spinner fa-spin"></i> Finding matters...
      </div>

      <div *ngIf="!loadingMatters && suggestedMatters.length > 0">
        <h6>Matters with this phone number:</h6>
        <div class="list-group mb-3">
          <button type="button" class="list-group-item list-group-item-action"
            *ngFor="let matter of suggestedMatters"
            (click)="selectMatter(matter)">
            {{ matter.label }}
          </button>
        </div>
      </div>

      <div *ngIf="!loadingMatters && suggestedMatters.length === 0" class="alert alert-warning">
        No matters found with this phone number. The call timer is running — select a matter to create a billing.
      </div>
    </div>

    <!-- Billing Form (shown when matter is selected) -->
    <div *ngIf="matterSelected">
      <div *ngIf="matterLabel" class="mb-3">
        <strong>Matter:</strong> {{ matterLabel }}
      </div>

      <div *ngIf="!formOptionsLoaded" class="text-center py-3">
        <i class="fas fa-spinner fa-spin"></i> Loading billing options...
      </div>

      <div *ngIf="formOptionsLoaded">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Time (hours)</label>
              <input type="number" class="form-control" [(ngModel)]="quantity" (change)="manualTimeRateChange()" step="0.05" min="0">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Rate ($/hr)</label>
              <div class="input-group">
                <div class="input-group-prepend"><span class="input-group-text">$</span></div>
                <input type="number" class="form-control" [(ngModel)]="billing.rate" (change)="manualTimeRateChange()" step="1" min="0">
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Fee</label>
              <div class="input-group">
                <div class="input-group-prepend"><span class="input-group-text">$</span></div>
                <input type="text" class="form-control" [value]="totalCharge" readonly>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="phoneCallBillable" [(ngModel)]="billing.is_billable">
                <label class="custom-control-label" for="phoneCallBillable">Billable</label>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>User</label>
              <select class="form-control form-control-sm" [(ngModel)]="billing.user_id">
                <option *ngFor="let user of formOptions.users" [value]="user.value">{{ user.label }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" rows="2" [(ngModel)]="billing.description"></textarea>
        </div>

        <div class="form-group">
          <label>Matter History Note</label>
          <textarea class="form-control" rows="2" [(ngModel)]="historyMessage" placeholder="Optional note to add to matter history"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="saveBilling()" [disabled]="!matterSelected || !formOptionsLoaded || saving">
      <i class="fas fa-save" *ngIf="!saving"></i>
      <i class="fas fa-spinner fa-spin" *ngIf="saving"></i>
      Save
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="discard()">Discard</button>
  </div>
</ng-template>
